module.exports = __webpack_public_path__ + "static/media/Mustang341_4c.ab58bd2f.svg";